import React from "react";
import { Container, Row, Col, Card, Button } from "react-bootstrap";
import { FaBrain, FaLightbulb, FaFileAlt } from "react-icons/fa";
import { Link } from "react-router-dom";

const VisionaryAISection = () => {

    
  return (
    <section className="py-5 bg-light">
      <Container>
        {/* Section Header */}
        <div className="text-center mb-4">
          <h2 className="fw-bold text-primary">
            Visionary AI Agents for Competitive & Comprehensive Learning Paradigms
          </h2>
          <p className="text-muted">
            Empowering education through intelligent AI models that automate question generation,
            topic analysis, and resume creation for a holistic and future-ready learning experience.
          </p>
        </div>

        {/* Cards Row */}
        <Row className="g-4 justify-content-center">
          {/* AI Question Generator */}
          <Col xs={12} sm={6} md={4}>
            <Card className="shadow-lg border-0 h-100 hover-scale">
              <Card.Img
                variant="top"
                src="https://images.unsplash.com/photo-1635070041078-e363dbe005cb?auto=format&fit=crop&w=900&q=80
  "
                alt="AI Question Generator"
                className="rounded-top"
              />
              <Card.Body>
                <div className="d-flex align-items-center mb-3">
                  <FaBrain className="fs-2 text-primary me-2" />
                  <Card.Title className="fw-bold mb-0">
                    AI Question Generator
                  </Card.Title>
                </div>
                <Card.Text>
                  An advanced AI model that analyzes previous year papers across central, state,
                  and competitive exams to generate intelligent, topic-wise, and difficulty-balanced
                  questions for adaptive learning.
                </Card.Text>
                 {/* ✅ Navigation Button */}
          <div className="text-center mt-3">
            <Link to="/ai-questions-generator">
              <Button variant="primary" className="px-4">
                Get Started Now →
              </Button>
            </Link>
          </div>
              </Card.Body>
            </Card>
          </Col>

          {/* AI Topic Generator */}
          <Col xs={12} sm={6} md={4}>
            <Card className="shadow-lg border-0 h-100 hover-scale">
              <Card.Img
                variant="top"
                src="https://images.unsplash.com/photo-1550751827-4bd374c3f58b?auto=format&fit=crop&w=900&q=80"
                alt="AI Topic Generator"
                className="rounded-top"
              />
              <Card.Body>
                <div className="d-flex align-items-center mb-3">
                  <FaLightbulb className="fs-2 text-warning me-2" />
                  <Card.Title className="fw-bold mb-0">
                    AI Topic Generator
                  </Card.Title>
                </div>
                <Card.Text>
                  A cutting-edge AI system that intelligently generates topics, subtopics,
                  and concept hierarchies across all departments — enabling dynamic and
                  personalized learning journeys.
                </Card.Text>
                 {/* ✅ Navigation Button */}
          <div className="text-center mt-3">
            <Link to="/ai-topic-generator">
              <Button variant="primary" className="px-4">
                Explore Now →
              </Button>
            </Link>
          </div>
              </Card.Body>
            </Card>
          </Col>

          {/* AI Resume Generator */}
          <Col xs={12} sm={6} md={4}>
            <Card className="shadow-lg border-0 h-100 hover-scale">
              <Card.Img
                variant="top"
                src="https://images.unsplash.com/photo-1522202176988-66273c2fd55f?auto=format&fit=crop&w=900&q=80

                "
                alt="AI Resume Generator"
                className="rounded-top"
              />
              <Card.Body>
                <div className="d-flex align-items-center mb-3">
                  <FaFileAlt className="fs-2 text-success me-2" />
                  <Card.Title className="fw-bold mb-0">
                    AI Resume Generator
                  </Card.Title>
                </div>
                <Card.Text>
                  An intelligent AI-driven model that crafts professional, keyword-optimized resumes
                  tailored to candidate profiles, academic records, and job or internship opportunities.
                </Card.Text>
                 {/* ✅ Navigation Button */}
          <div className="text-center mt-3">
            <Link to="/ai_resumepage">
              <Button variant="primary" className="px-4">
                Explore →
              </Button>
            </Link>
          </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>

      {/* Inline CSS for hover animation */}
      <style>{`
        .hover-scale {
          transition: transform 0.3s ease, box-shadow 0.3s ease;
        }
        .hover-scale:hover {
          transform: translateY(-8px) scale(1.02);
          box-shadow: 0 10px 25px rgba(0,0,0,0.15);
        }
        @media (max-width: 576px) {
          h2 {
            font-size: 1.4rem;
          }
          .card img {
            height: 180px;
            object-fit: cover;
          }
        }
      `}</style>
    </section>
  );
};

export default VisionaryAISection;
